/**
 * 加载app单元
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { loadApp } from './appMiddleware'

class AppLoader extends Component {

  static contextTypes = {
    store: PropTypes.object
  }

  constructor (props, context) {
    super(props, context)
  }

  componentDidMount () {

  }

  render () {
    const {appName} = this.props

    return loadApp(appName)
  }
}

export default AppLoader


// WEBPACK FOOTER //
// ./src/wbap-core-commit/appLoader.js